export default "__VITE_ASSET__DzYOGZHa__"